import { defineSlotRecipe } from '@chakra-ui/react'

export const customTabs = defineSlotRecipe({
  className: 'CustomTabs',
  slots: ['tabWrap', 'tabList', 'tabListButton', 'tabContent'],
  base: {
    tabWrap: {
      display: 'grid',
      gridTemplate: {
        base: `'tabs tabs' auto
        'content content' auto
        / minmax(0, max-content) 1fr`,
        lg: `'tabs .' auto
        'content content' auto
        / minmax(0, max-content) 1fr`,
      },
      _before: { content: '""', gridArea: 'content-start', marginBottom: 8 },
    },
    tabList: {
      gridArea: 'tabs',
      padding: '0',
      listStyle: 'none',
      display: 'flex',
      alignItems: 'flex-end',
      overflow: 'auto',
      zIndex: 1,
      // ariaOrientation: 'horizontal',
      margin: 0,
    },
    tabListButton: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: 'none',
      fontSize: 'md',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      cursor: 'pointer',

      border: 'solid 1px',
      borderColor: 'var(--alto-sem-color-fg-accent-secondary)',
      bgColor: 'var(--alto-sem-color-fg-accent-primary)',
      color: 'var(--alto-sem-color-bg-layer2-default)',

      _focusVisible: {
        outlineStyle: 'solid',
        outlineColor: 'var(--alto-sem-color-bg-layer2-default)',
        position: 'relative',
      },

      '&[aria-current=page]': {
        height: 16,
        p: '12px 32px',
        border: 'none',
        bgColor: 'var(--alto-sem-color-bg-layer1-default)',
        color: 'var(--alto-sem-color-fg-primary)',
      },
    },
    tabContent: {
      gridArea: 'content',
      padding: 6,
      minHeight: 10,
      boxShadow: '0 6px 9px 0 rgba(0, 0, 0, 0.1)',
      borderRadius: {
        base: '0',
        lg: '10px',
      },
    },
  },
})
